import * as t from 'io-ts';
import * as tp from 'io-ts-promise';
import axios, { AxiosResponse } from 'axios';

import Data from '../../Data';
import Endpoints from '../endpoints';
import { getDataFromAxios } from '../common';
import { DetailOrganisationResponse } from './response_models';

export const RemoveUserFromBranchRequest = t.exact(
  t.type({
    branchId: t.string,
    userId: t.string,
  }),
);

export type RemoveUserFromBranchRequest = t.TypeOf<typeof RemoveUserFromBranchRequest>;

export const removeUserFromBranch = (request: RemoveUserFromBranchRequest): Promise<AxiosResponse<DetailOrganisationResponse>> =>
  axios.delete(Endpoints.organisations.USER_BRANCH(), {
    data: {
      userId: request.userId,
      branchId: request.branchId,
    },
    headers: {
      'X-TOKEN': Data.store.getState().authentication.credentials.token,
    },
  });

export default async (request: RemoveUserFromBranchRequest) =>
  await removeUserFromBranch(request).then(getDataFromAxios.get).then(tp.decode(DetailOrganisationResponse));
